import { render, staticRenderFns } from "./SampleResultChemical.vue?vue&type=template&id=bafcdb5c&scoped=true"
import script from "./SampleResultChemical.vue?vue&type=script&lang=js"
export * from "./SampleResultChemical.vue?vue&type=script&lang=js"
import style0 from "./SampleResultChemical.vue?vue&type=style&index=0&id=bafcdb5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafcdb5c",
  null
  
)

export default component.exports